import { computed, makeObservable, observable, when } from 'mobx';
import { TimerStore } from './TimerStore';
import { MraidStore } from './MraidStore';

interface CountdownStoreProps {
  timer?: TimerStore;
  mraidStore: MraidStore;
}

export class CountdownStore {
  timer?: TimerStore;
  mraidStore: MraidStore;

  _timeout: NodeJS.Timeout | number | undefined;
  _tick: number = 0;

  constructor({ timer, mraidStore }: CountdownStoreProps) {
    this.mraidStore = mraidStore;
    this.timer = timer;

    makeObservable(this, {
      _tick: observable,
      tick: computed
    });
  }

  bindTimer(timer: TimerStore) {
    this.timer = timer;

    if (!this.mraidStore) {
      return;
    }

    when(
      () => this.mraidStore.isViewable,
      () => this.startTimer()
    );
  }

  startTimer() {
    this.incrementTick();
  }

  incrementTick() {
    if (!this.timer) {
      throw new Error('Timer of Countdown store not bound');
    }
    this._tick = this.timer.tick;
    if (!this.timer.isFinished && !this.timer.isPaused)
      this._timeout = setTimeout(() => this.incrementTick(), 1000);
    else clearTimeout(this._timeout as undefined);
  }

  get tick() {
    return this._tick;
  }
}
